import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";
import { TGastroPayModel } from "./components/modules/GastroPay/types/TGastroPayModel";

export const orderLocationsFetch = (config?: AxiosRequestConfig) =>
    request(
        types.FETCH_REQUEST,
        types.FETCH_FAILED,
        types.FETCH_SUCCESS,
        "orderLocationsFetch",
        {
            config,
        },
        undefined,
        undefined,
        "order",
    );

export const orderLocationsGet = (id: number) =>
    request(
        types.GET_REQUEST,
        types.GET_FAILED,
        types.GET_SUCCESS,
        "orderLocationsGet",
        {
            url: {
                id,
            },
        },
        undefined,
        undefined,
        "order",
    );

export const orderLocationModulesFetch = (locationId: number) =>
    request(
        types.MODULES_FETCH_REQUEST,
        types.MODULES_FETCH_FAILED,
        types.MODULES_FETCH_SUCCESS,
        "orderLocationModulesFetch",
        {
            url: {
                locationId,
            },
        },
        undefined,
        undefined,
        "order",
    );

export const orderLocationModulesDatatransGateway = (
    locationId: number,
    onResponse?: Function,
) =>
    request(
        types.DATATRANS_GATEWAY_REQUEST,
        types.DATATRANS_GATEWAY_FAILED,
        types.DATATRANS_GATEWAY_SUCCESS,
        "orderLocationModulesDatatransGateway",
        {
            url: {
                locationId,
            },
        },
        onResponse,
        undefined,
        "order",
    );

export const orderLocationModulesGastroPayConfigure = (
    locationId: number,
    data: TGastroPayModel,
    onResponse: Function,
) =>
    request(
        types.GASTROPAY_CONFIGURE_REQUEST,
        types.GASTROPAY_CONFIGURE_FAILED,
        types.GASTROPAY_CONFIGURE_SUCCESS,
        "orderLocationModulesGastroPayConfigure",
        {
            data,
            url: {
                locationId,
            },
        },
        onResponse,
        undefined,
        "order",
    );

export const orderLocationModulesGastroPayGateway = (
    locationId: number,
    onResponse?: Function,
) =>
    request(
        types.GASTROPAY_GATEWAY_REQUEST,
        types.GASTROPAY_GATEWAY_FAILED,
        types.GASTROPAY_GATEWAY_SUCCESS,
        "orderLocationModulesGastroPayGateway",
        {
            url: {
                locationId,
            },
        },
        onResponse,
        undefined,
        "order",
    );

export const orderLocationModulesGastroPayRemove = (
    locationId: number,
    onResponse: Function,
) =>
    request(
        types.GASTROPAY_REMOVE_REQUEST,
        types.GASTROPAY_REMOVE_FAILED,
        types.GASTROPAY_REMOVE_SUCCESS,
        "orderLocationModulesGastroPayRemove",
        {
            url: {
                locationId,
            },
        },
        onResponse,
        undefined,
        "order",
    );

export const orderLocationModulesGastroPayUpdate = (
    locationId: number,
    data: TGastroPayModel,
    onResponse: Function,
) =>
    request(
        types.GASTROPAY_UPDATE_REQUEST,
        types.GASTROPAY_UPDATE_FAILED,
        types.GASTROPAY_UPDATE_SUCCESS,
        "orderLocationModulesGastroPayUpdate",
        {
            data,
            url: {
                locationId,
            },
        },
        onResponse,
        undefined,
        "order",
    );

export const orderLocationsTableUpdate = (action: string, data: any) => ({
    type: types.TABLE_UPDATE,
    action,
    data,
});
